import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Container } from "@perxis-auto/ui-kit/lib";
import { Button } from "@perxis-auto/ui-kit/lib/components/Button";
import Empty from "@perxis-auto/ui-kit/lib/components/Empty/Empty";
import { Icon } from "@perxis-auto/ui-kit/lib/components/Icon";
import clsx from "clsx";
import "../../../shared/context/constructor.js";
import { ThisProvider } from "../../../shared/context/this.js";
import { Constructor } from "../../../shared/ui/constructor/Constructor.js";
import { Link } from "../../../shared/ui/link/Link.js";
import { BottomNav } from "./bottomNav/BottomNav.js";
import { SideNav } from "./sideNav/SideNav.js";
import styles from "./ComparisonList.module.scss.js";
const ComparisonList = memo(function ComparisonList2({
  t,
  sideNavRef,
  sideNavHeight,
  items,
  total,
  getBottomNavIndex,
  onNextClick,
  onPrevClick,
  isBottomNavHidden,
  isSideNavHidden,
  isNextDisabled,
  isPrevDisabled,
  redirect,
  isLoading,
  isSticky,
  isEmpty,
  onBackClick,
  layout,
  widgets
}) {
  if (isEmpty) {
    return /* @__PURE__ */ jsx(
      Empty,
      {
        title: t("widgets.comparisonList.empty.title"),
        description: t("widgets.comparisonList.empty.description"),
        children: /* @__PURE__ */ jsx(Button, { type: "ghost", icon: /* @__PURE__ */ jsx(Icon, { name: "forward", sticker: "comparison-list-back-icon" }), onClick: onBackClick, children: t("widgets.comparisonList.empty.backLabel") })
      }
    );
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: clsx(styles.comparisonList, {
        [styles["comparisonList--sticky"]]: isSticky
      }),
      children: /* @__PURE__ */ jsx(Container, { className: styles.comparisonList__container, children: /* @__PURE__ */ jsxs(
        "div",
        {
          className: styles.comparisonList__body,
          style: { "--pa-comparison-list-body-min-height": sideNavHeight ? `${sideNavHeight}px` : null },
          children: [
            /* @__PURE__ */ jsx("div", { className: clsx(styles.comparisonList__track), children: items == null ? void 0 : items.map((item) => {
              var _a;
              return /* @__PURE__ */ jsx(ThisProvider, { data: item, isLoading, children: /* @__PURE__ */ jsxs("div", { className: styles.comparisonList__item, children: [
                /* @__PURE__ */ jsxs(
                  Link,
                  {
                    ...redirect.options,
                    to: redirect.to,
                    params: {
                      ...(_a = redirect.options) == null ? void 0 : _a.params,
                      vehicleId: item.id
                    },
                    children: [
                      isSticky && /* @__PURE__ */ jsx(Constructor, { isSubConstructor: true, space: "header", layout, widgets }),
                      !isSticky && /* @__PURE__ */ jsx(Constructor, { isSubConstructor: true, space: "list", layout, widgets })
                    ]
                  }
                ),
                /* @__PURE__ */ jsxs(
                  BottomNav,
                  {
                    onPrevClick: (e) => onPrevClick(item.id, e),
                    onNextClick: (e) => onNextClick(item.id, e),
                    isHidden: isBottomNavHidden,
                    children: [
                      getBottomNavIndex(item.id),
                      " из ",
                      total
                    ]
                  }
                )
              ] }) }, item.id);
            }) }),
            /* @__PURE__ */ jsx(
              SideNav,
              {
                ref: sideNavRef,
                total,
                onPrevClick: (e) => onPrevClick(null, e),
                onNextClick: (e) => onNextClick(null, e),
                isNextDisabled,
                isPrevDisabled,
                isHidden: isSideNavHidden
              }
            )
          ]
        }
      ) })
    }
  );
});
export {
  ComparisonList
};
